import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { familyDetailEditSchema } from '../../../ValidationSchema';
import { editFamilyDetails, getFamilyStatus, getFamilyType, getFamilyValue } from '../../../../asiosConfig';
import Popup from '../../../Popup';
import { Button, Card, CardContent, CardHeader, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const AboutMyFamilyEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [familyTypes, setFamilyTypes] = useState([]);
  const [familyStatuses, setFamilyStatuses] = useState([]);
  const [familyValues, setFamilyValues] = useState([]);
  const userProfileData = location.state?.userProfileData || {};
  const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

  const handleClosePopup = () => {
    setPopupData({ ...popupData, open: false });
  };

  useEffect(() => {
    if (popupData.open) {
      const timer = setTimeout(() => {
        setPopupData(prev => ({ ...prev, open: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popupData.open]);

  const formik = useFormik({
    initialValues: {
      familyValue: userProfileData.familyValue || '',
      familyType: userProfileData.familyType || '',
      familyStatus: userProfileData.familyStatus || '',
      fatherName: userProfileData.fatherName || '',
      fatherProfessions: userProfileData.fatherProfessions || '',
      motherName: userProfileData.motherName || '',
      motherProfession: userProfileData.motherProfession || '',
      marriedSister: userProfileData.marriedSister || 0,
      unMarriedSister: userProfileData.unMarriedSister || 0,
      marriedBrothers: userProfileData.marriedBrothers || 0,
      unMarriedBrothers: userProfileData.unMarriedBrothers || 0,
      familyOrigin: userProfileData.familyOrigin || '',
      aboutFamily: userProfileData.aboutFamily || '',

    },
    validationSchema: familyDetailEditSchema,
    onSubmit: async (values, { setSubmit }) => {
      try {
        // const tokan = localStorage.getItem('token');
        const response = await editFamilyDetails({ ...values });
        if (response.status === 200 || response.status === 201) {
          setPopupData({ open: true, type: 'success', message: 'Successfully updated the family details' });
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        } else {
          setPopupData({ open: true, type: 'error', message: 'Failed to update the family details' });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.success || "An error occurred" });
      } finally {
        setSubmit(false);
      }
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [familyValueRes, familyTypeRes, familyStatusRes] = await Promise.all([
          getFamilyValue(),
          getFamilyType(),
          getFamilyStatus(),
        ]);
        if (familyValueRes.status === 200 || familyValueRes.status === 201) {
          setFamilyValues(familyValueRes.data.data);
        }

        if (familyTypeRes.status === 200 || familyTypeRes.status === 201) {
          setFamilyTypes(familyTypeRes.data.data);
        }

        if (familyStatusRes.status === 200 || familyStatusRes.status === 201) {
          setFamilyStatuses(familyStatusRes.data.data);
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.response?.data?.message || 'Failed to fetch data' });
      }
    }
    fetchData();
  }, []);
  return (
    <div className="col-lg-9 col-12">
      <Card className="editProfileBlock">
        <CardHeader
          avatar={<ArrowBackIcon sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
          title="Family Details"
          subheader="Elaborate on your family information"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
        />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Family Value"
                  variant="outlined"
                  className="mb-3"
                  name="familyValue"
                  value={formik.values.familyValue}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.familyValue && Boolean(formik.errors.familyValue)}
                  helperText={formik.touched.familyValue && formik.errors.familyValue}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                >
                  <MenuItem value="">Select Family Value</MenuItem>
                  {familyValues.map((value) => (
                    <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Family Type"
                  variant="outlined"
                  className="mb-3"
                  name="familyType"
                  value={formik.values.familyType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.familyType && Boolean(formik.errors.familyType)}
                  helperText={formik.touched.familyType && formik.errors.familyType}
                >
                  <MenuItem value="">Select Family Type</MenuItem>
                  {familyTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Family Status"
                  variant="outlined"
                  className="mb-3"
                  name="familyStatus"
                  value={formik.values.familyStatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.familyStatus && Boolean(formik.errors.familyStatus)}
                  helperText={formik.touched.familyStatus && formik.errors.familyStatus}
                >
                  <MenuItem value="">Select Family Status</MenuItem>
                  {familyStatuses.map((status) => (
                    <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Family Origin"
                  variant="outlined"
                  className="mb-3"
                  name="familyOrigin"
                  value={formik.values.familyOrigin}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.familyOrigin && Boolean(formik.errors.familyOrigin)}
                  helperText={formik.touched.familyOrigin && formik.errors.familyOrigin}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Father's Name"
                  variant="outlined"
                  className="mb-3"
                  name="fatherName"
                  value={formik.values.fatherName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.fatherName && Boolean(formik.errors.fatherName)}
                  helperText={formik.touched.fatherName && formik.errors.fatherName}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Father's Professions"
                  variant="outlined"
                  className="mb-3"
                  name="fatherProfessions"
                  value={formik.values.fatherProfessions}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.fatherProfessions && Boolean(formik.errors.fatherProfessions)}
                  helperText={formik.touched.fatherProfessions && formik.errors.fatherProfessions}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Mother's Name"
                  variant="outlined"
                  className="mb-3"
                  name="motherName"
                  value={formik.values.motherName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.motherName && Boolean(formik.errors.motherName)}
                  helperText={formik.touched.motherName && formik.errors.motherName}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Mother's Profession"
                  variant="outlined"
                  className="mb-3"
                  name="motherProfession"
                  value={formik.values.motherProfession}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.motherProfession && Boolean(formik.errors.motherProfession)}
                  helperText={formik.touched.motherProfession && formik.errors.motherProfession}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <FormControl fullWidth variant="outlined" className="mb-3" error={formik.touched.marriedSister && Boolean(formik.errors.marriedSister)}>
                  <InputLabel id="marriedSister-label">Married Sisters</InputLabel>
                  <Select
                    labelId="marriedSister-label"
                    id="marriedSister"
                    name="marriedSister"
                    value={formik.values.marriedSister !== null && formik.values.marriedSister !== undefined ? formik.values.marriedSister : ''}
                    onChange={(e) => formik.setFieldValue('marriedSister', e.target.value)}
                    onBlur={formik.handleBlur}
                    label="Married Sisters"
                  >
                    {[...Array(6).keys()].map((value) => (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.marriedSister && formik.errors.marriedSister && (
                    <FormHelperText>{formik.errors.marriedSister}</FormHelperText>
                  )}
                </FormControl>
              </div>





              <div className="col-md-6">
                <FormControl fullWidth variant="outlined" className="mb-3" error={formik.touched.unMarriedSister && Boolean(formik.errors.unMarriedSister)}>
                  <InputLabel id="unMarriedSister-label">Unmarried Sisters</InputLabel>
                  <Select
                    labelId="unMarriedSister-label"
                    id="unMarriedSister"
                    name="unMarriedSister"
                    value={formik.values.unMarriedSister !== null && formik.values.unMarriedSister !== undefined ? formik.values.unMarriedSister : ''}
                    onChange={(e) => formik.setFieldValue('unMarriedSister', e.target.value)}
                    onBlur={formik.handleBlur}
                    label="Unmarried Sisters"
                  >
                    {[...Array(6).keys()].map((value) => (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.unMarriedSister && formik.errors.unMarriedSister && (
                    <FormHelperText>{formik.errors.unMarriedSister}</FormHelperText>
                  )}
                </FormControl>
              </div>

              <div className="col-md-6">
                <FormControl fullWidth variant="outlined" className="mb-3" error={formik.touched.marriedBrothers && Boolean(formik.errors.marriedBrothers)}>
                  <InputLabel id="marriedBrothers-label">Married Brothers</InputLabel>
                  <Select
                    labelId="marriedBrothers-label"
                    id="marriedBrothers"
                    name="marriedBrothers"
                    value={formik.values.marriedBrothers !== null && formik.values.marriedBrothers !== undefined ? formik.values.marriedBrothers : ''}
                    onChange={(e) => formik.setFieldValue('marriedBrothers', e.target.value)}
                    onBlur={formik.handleBlur}
                    label="Married Brothers"
                  >
                    {[...Array(6).keys()].map((value) => (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.marriedBrothers && formik.errors.marriedBrothers && (
                    <FormHelperText>{formik.errors.marriedBrothers}</FormHelperText>
                  )}
                </FormControl>
              </div>


              <div className="col-md-6">
                <FormControl fullWidth variant="outlined" className="mb-3" error={formik.touched.unMarriedBrothers && Boolean(formik.errors.unMarriedBrothers)}>
                  <InputLabel id="unMarriedBrothers-label">Unmarried Brothers</InputLabel>
                  <Select
                    labelId="unMarriedBrothers-label"
                    id="unMarriedBrothers"
                    name="unMarriedBrothers"
                    value={formik.values.unMarriedBrothers !== null && formik.values.unMarriedBrothers !== undefined ? formik.values.unMarriedBrothers : ''}
                    onChange={(e) => formik.setFieldValue('unMarriedBrothers', e.target.value)}
                    onBlur={formik.handleBlur}
                    label="Unmarried Brothers"
                  >
                    {[...Array(6).keys()].map((value) => (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.unMarriedBrothers && formik.errors.unMarriedBrothers && (
                    <FormHelperText>{formik.errors.unMarriedBrothers}</FormHelperText>
                  )}
                </FormControl>
              </div>
              <div className="col-md-12">
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="About Family"
                  variant="outlined"
                  className="mb-3"
                  name="aboutFamily"
                  value={formik.values.aboutFamily}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.aboutFamily && Boolean(formik.errors.aboutFamily)}
                  helperText={formik.touched.aboutFamily && formik.errors.aboutFamily}
                />
              </div>
            </div>
            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
            <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
              {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
            </Button>
            {/* </div> */}

          </form>
        </CardContent>
      </Card>

      <Popup
        open={popupData.open}
        type={popupData.type}
        message={popupData.message}
        onClose={handleClosePopup}
      />
    </div >
  )
}
